export interface Olympiad {
  name: string
  url?: string
  dates: string
  status?: OlympiadStatus | string
  olympiad_id?: string
  olympiad_start?: string
  olympiad_end?: string
  icon?: string
  hint?: string | null
  popup_text?: string | null
}

export enum OlympiadStatus {
  'current' = 'current',
  'passed' = 'passed',
  'future' = 'future'
}

export const olympiadStatusTranslate = {
  [OlympiadStatus.current]: 'Проходит',
  [OlympiadStatus.future]: 'Пройдет',
  [OlympiadStatus.passed]: 'Прошла'
}

export const olympiadStatusTextColor = {
  [OlympiadStatus.passed]: 'var(--black-60)',
  [OlympiadStatus.current]: 'var(--purple-100)',
  [OlympiadStatus.future]: 'var(--blue-100)',
}

export const olympiadStatusBgColor = {
  [OlympiadStatus.passed]: 'var(--black-5)',
  [OlympiadStatus.current]: 'var(--purple-10)',
  [OlympiadStatus.future]: 'var(--blue-10)',
}

export const olympiadStatusFilterOrder: OlympiadStatus[] = [
  OlympiadStatus.future,
  OlympiadStatus.current,
  OlympiadStatus.passed,
]

export const defaultOlympiadStatusesFilter = []

export const toggleOlympiadStatusFilter = (
  selectedStatuses: OlympiadStatus[],
  status: OlympiadStatus
): OlympiadStatus[] =>
  selectedStatuses.includes(status)
    ? selectedStatuses.filter((item) => item !== status)
    : [...selectedStatuses, status]